module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <header class=\"col-12\">\n      <h1>Doxa Soft</h1>\n    </header>\n    <div class=\"col-12\">\n      <ul>\n          <li *ngFor=\"let site of sites\"><a href=\"{{ site.url }}\" target=\"_blank\">{{ site.name }}</a></li>\n      </ul>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/manuel/Sites/doxasoft/sites/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main